import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../home/components/Footer';

const plusSizeGrowth = [
  { month: 'Окт 2022', label: '0 ₽', value: 0, units: 0 },
  { month: 'Июль 2023', label: '1,76 млн ₽', value: 1760000, units: 571 },
  { month: 'Ноя 2024', label: '7,19 млн ₽', value: 7188461, units: null },
  { month: 'Май 2025', label: '14,18 млн ₽', value: 14178431, units: null },
  { month: 'Ноя 2025', label: '24,6 млн ₽', value: 24600000, units: null, highlight: true }
];

const maxPlusSizeValue = Math.max(...plusSizeGrowth.map(d => d.value));

export default function CaseLargeSizeClothingPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white font-['Montserrat']">
      <Navbar />

      {/* ─── HERO ─── */}
      <section className="pt-32 pb-20 bg-[#1A2B4C] relative overflow-hidden">
        {/* Декоративные кольца */}
        <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full border border-[#C5A880]/10 translate-x-1/3 -translate-y-1/3 pointer-events-none" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full border border-[#C5A880]/10 -translate-x-1/3 translate-y-1/3 pointer-events-none" />
        <div className="absolute top-1/2 left-1/2 w-[800px] h-[800px] rounded-full border border-[#C5A880]/5 -translate-x-1/2 -translate-y-1/2 pointer-events-none" />

        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <Link
            to="/case"
            className="inline-flex items-center gap-2 text-[#C5A880] hover:text-white transition-colors mb-10 cursor-pointer"
          >
            <i className="ri-arrow-left-line text-lg"></i>
            <span className="text-sm font-medium tracking-wide">Назад к кейсам</span>
          </Link>

          <div className="inline-flex items-center gap-2 bg-[#C5A880]/15 border border-[#C5A880]/40 text-[#C5A880] px-5 py-2 rounded-full text-sm font-semibold mb-6 tracking-widest uppercase">
            <i className="ri-rocket-line"></i>
            Флагманский кейс · Маркетплейс Ozon
          </div>

          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 leading-tight font-['Playfair_Display']">
            Масштабирование до 24,6 млн ₽<br />в нише Plus Size
          </h1>
          <p className="text-white/55 text-lg mt-2 mb-12 font-['Montserrat']">
            Женская одежда больших размеров (52–72) · Собственное производство · 1 400 SKU
          </p>

          {/* Key stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { icon: 'ri-rocket-line', label: 'Старт', value: '0 ₽' },
              { icon: 'ri-trophy-line', label: 'Результат', value: '24,6 млн ₽' },
              { icon: 'ri-time-line', label: 'Период', value: '3 года' },
              { icon: 'ri-t-shirt-line', label: 'Ассортимент', value: '1 400 SKU' },
            ].map((stat, i) => (
              <div key={i} className="bg-white/8 border border-[#C5A880]/20 rounded-2xl p-6 text-center hover:border-[#C5A880]/50 transition-all duration-300">
                <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                  <i className={`${stat.icon} text-2xl text-[#C5A880]`}></i>
                </div>
                <div className="text-2xl font-bold text-white font-['Playfair_Display']">{stat.value}</div>
                <div className="text-white/45 text-sm mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── ЗАДАЧА / НИША / ПЕРИОД ─── */}
      <section className="py-20 bg-[#F8F9FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-6">
            {[
              {
                icon: 'ri-flag-line',
                title: 'Задача',
                sub: 'Управление гигантом',
                text: 'Запустить продажи с нуля для огромного ассортимента (1 400 артикулов), выстроить логистику по всей стране и обеспечить загрузку производства в условиях высокой конкуренции.',
              },
              {
                icon: 'ri-t-shirt-line',
                title: 'Ниша',
                sub: 'Plus Size (52–72 размеры)',
                text: 'Высокая требовательность аудитории к посадке и визуалу. Необходимость закрывать специфические боли целевой аудитории через контент.',
              },
              {
                icon: 'ri-calendar-line',
                title: 'Период',
                sub: 'Ноябрь 2022 — настоящее время',
                text: 'Устойчивый рост на длинной дистанции — лучшее доказательство эффективности системного подхода.',
                big: '3 года',
              },
            ].map((card, i) => (
              <div key={i} className="bg-white rounded-2xl p-8 border border-[#C5A880]/20 hover:border-[#C5A880]/50 hover:shadow-lg transition-all duration-300 group">
                <div className="w-12 h-12 bg-[#1A2B4C] rounded-xl flex items-center justify-center mb-5 group-hover:bg-[#C5A880] transition-colors duration-300">
                  <i className={`${card.icon} text-xl text-[#C5A880] group-hover:text-[#1A2B4C]`}></i>
                </div>
                <h4 className="text-xl font-bold text-[#1A2B4C] mb-1 font-['Playfair_Display']">{card.title}</h4>
                <p className="text-[#C5A880] text-sm font-semibold mb-3">{card.sub}</p>
                {card.big && (
                  <div className="text-4xl font-bold text-[#1A2B4C] font-['Playfair_Display'] mb-3">{card.big}</div>
                )}
                <p className="text-gray-600 text-sm leading-relaxed">{card.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── СТРАТЕГИЯ ─── */}
      <section className="py-20 bg-[#1A2B4C] relative overflow-hidden">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full border border-[#C5A880]/8 translate-x-1/3 -translate-y-1/3 pointer-events-none" />
        <div className="absolute bottom-0 left-0 w-[350px] h-[350px] rounded-full border border-[#C5A880]/8 -translate-x-1/3 translate-y-1/3 pointer-events-none" />

        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="text-center mb-14">
            <div className="inline-flex items-center gap-2 bg-[#C5A880]/15 border border-[#C5A880]/30 text-[#C5A880] px-5 py-2 rounded-full text-xs font-semibold tracking-widest uppercase mb-5">
              Методология
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white font-['Playfair_Display'] mb-4">
              Стратегия «Ковровое покрытие»
            </h2>
            <div className="w-16 h-px bg-[#C5A880] mx-auto mb-4" />
            <p className="text-white/50 text-lg max-w-2xl mx-auto">
              Управление 1 400 SKU требует жёсткой системы и автоматизации
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-5">
            {[
              {
                icon: 'ri-image-line',
                num: '01',
                title: 'Тотальная проработка контента (1 400 SKU)',
                items: [
                  'Инфографика, закрывающая боли Plus Size (посадка, скрытие недостатков)',
                  'SEO: максимальное заполнение характеристик для попадания в узкие фильтры',
                  'Сбор низкочастотного трафика по всем артикулам',
                ]
              },
              {
                icon: 'ri-map-pin-line',
                num: '02',
                title: 'Гео-распределённая логистика (FBO)',
                items: [
                  'Товары распределены по всем кластерам и складам Ozon',
                  'Товар рядом с покупателем в любом регионе',
                  'Ozon ранжирует карточки выше → быстрая доставка',
                ]
              },
              {
                icon: 'ri-rocket-line',
                num: '03',
                title: 'Локомотивы продаж',
                items: [
                  'Выделили товары-локомотивы (основной: Джемпер женский)',
                  'Сфокусировали бюджет на их прокачке',
                  'Они «тянут» за собой остальной ассортимент',
                ]
              },
              {
                icon: 'ri-advertisement-line',
                num: '04',
                title: 'Маркетинговый микс',
                items: [
                  'Активная внутренняя реклама (клик, заказ, акции, бонусы)',
                  'Авторассылка, звёздные товары, отзывы за баллы',
                  'Внешний трафик: коллаборация с ВКонтакте Маркет',
                ]
              }
            ].map((item, i) => (
              <div key={i} className="bg-white/6 border border-[#C5A880]/15 rounded-2xl p-7 hover:bg-white/10 hover:border-[#C5A880]/40 transition-all duration-300 group">
                <div className="flex items-start gap-5">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 bg-[#C5A880] rounded-xl flex items-center justify-center mb-2">
                      <i className={`${item.icon} text-xl text-[#1A2B4C]`}></i>
                    </div>
                    <div className="text-[#C5A880]/25 text-3xl font-bold font-['Playfair_Display'] leading-none">{item.num}</div>
                  </div>
                  <div>
                    <h5 className="text-lg font-bold text-white mb-3 font-['Playfair_Display']">{item.title}</h5>
                    <ul className="space-y-2">
                      {item.items.map((li, j) => (
                        <li key={j} className="flex items-start gap-2 text-sm text-white/55">
                          <span className="w-1.5 h-1.5 rounded-full bg-[#C5A880] flex-shrink-0 mt-1.5" />
                          {li}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── ХРОНОЛОГИЯ РОСТА ─── */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-14">
            <div className="inline-flex items-center gap-2 bg-[#1A2B4C]/8 border border-[#1A2B4C]/15 text-[#1A2B4C] px-5 py-2 rounded-full text-xs font-semibold tracking-widest uppercase mb-5">
              Результаты
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#1A2B4C] font-['Playfair_Display'] mb-4">
              Хронология взрывного роста
            </h2>
            <div className="w-16 h-px bg-[#C5A880] mx-auto mb-4" />
            <p className="text-gray-500 text-lg max-w-2xl mx-auto">
              Не просто старт, а системное удвоение оборотов на длинной дистанции
            </p>
          </div>

          {/* Bar Chart */}
          <div className="bg-[#F8F9FA] rounded-2xl p-8 border border-[#C5A880]/20 mb-8">
            <div className="flex items-center gap-4 mb-10">
              <div className="w-12 h-12 bg-[#1A2B4C] rounded-xl flex items-center justify-center">
                <i className="ri-bar-chart-box-line text-2xl text-[#C5A880]"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-[#1A2B4C] font-['Playfair_Display']">Ozon · Plus Size Fashion</h3>
                <p className="text-gray-500 text-sm">Рост с 0 до 24,6 млн ₽ за 3 года</p>
              </div>
            </div>

            <div className="relative h-80 flex items-end justify-between gap-3 mb-6">
              {plusSizeGrowth.map((data, index) => (
                <div key={index} className="flex-1 flex flex-col items-center">
                  <div className="w-full relative" style={{ height: '280px' }}>
                    <div
                      className={`absolute bottom-0 w-full rounded-t-xl transition-all duration-500 hover:opacity-90 ${
                        data.highlight
                          ? 'bg-gradient-to-t from-[#C5A880] to-[#1A2B4C] shadow-xl shadow-[#C5A880]/30'
                          : 'bg-gradient-to-t from-[#1A2B4C] to-[#1A2B4C]/60'
                      }`}
                      style={{ height: `${Math.max((data.value / maxPlusSizeValue) * 100, 2)}%` }}
                    >
                      <div className={`absolute -top-14 left-1/2 transform -translate-x-1/2 px-3 py-2 rounded-xl text-xs font-bold whitespace-nowrap shadow-lg ${
                        data.highlight
                          ? 'bg-[#C5A880] text-[#1A2B4C]'
                          : 'bg-[#1A2B4C] text-white'
                      }`}>
                        {data.label}
                        {data.units ? <div className="text-xs mt-0.5 opacity-80">{data.units} шт</div> : null}
                      </div>
                    </div>
                  </div>
                  <div className={`text-xs mt-3 text-center ${data.highlight ? 'text-[#1A2B4C] font-bold' : 'text-gray-500'}`}>
                    {data.month}
                  </div>
                </div>
              ))}
            </div>

            {/* Этапы */}
            <div className="grid md:grid-cols-4 gap-4">
              {[
                { num: '01', title: 'Запуск', period: 'Окт 2022 → Июль 2023', value: '1,76 млн ₽', sub: 'Первые миллионы · 571 шт', highlight: false },
                { num: '02', title: 'Уверенный рост', period: 'Ноябрь 2024', value: '7,19 млн ₽', sub: 'Стабильные показатели', highlight: false },
                { num: '03', title: 'Масштабирование ×2', period: 'Май 2025', value: '14,18 млн ₽', sub: 'Удвоение к предыдущему рекорду', highlight: false },
                { num: '04', title: 'Новый рекорд', period: 'Ноябрь 2025', value: '24,6 млн ₽', sub: 'Рост продолжается', highlight: true },
              ].map((stage, i) => (
                <div key={i} className={`rounded-xl p-5 border ${stage.highlight ? 'bg-[#1A2B4C] border-[#C5A880]/40' : 'bg-white border-[#C5A880]/20'}`}>
                  <div className={`text-xs font-bold tracking-widest uppercase mb-1 ${stage.highlight ? 'text-[#C5A880]' : 'text-[#1A2B4C]/40'}`}>
                    Этап {stage.num}
                  </div>
                  <div className={`text-sm font-bold mb-1 ${stage.highlight ? 'text-white' : 'text-[#1A2B4C]'}`}>{stage.title}</div>
                  <div className={`text-xs mb-2 ${stage.highlight ? 'text-white/40' : 'text-gray-400'}`}>{stage.period}</div>
                  <div className={`text-xl font-bold font-['Playfair_Display'] ${stage.highlight ? 'text-[#C5A880]' : 'text-[#1A2B4C]'}`}>{stage.value}</div>
                  <div className={`text-xs mt-1 ${stage.highlight ? 'text-white/50' : 'text-gray-400'}`}>{stage.sub}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Итоговый баннер */}
          <div className="bg-[#1A2B4C] rounded-2xl p-8 text-center relative overflow-hidden">
            <div className="absolute inset-0 pointer-events-none">
              <div className="absolute top-0 left-1/2 w-[400px] h-[400px] rounded-full border border-[#C5A880]/10 -translate-x-1/2 -translate-y-1/2" />
            </div>
            <div className="relative z-10">
              <div className="text-[#C5A880]/50 text-sm font-semibold tracking-widest uppercase mb-2">Итоговый результат</div>
              <div className="text-5xl font-bold text-white font-['Playfair_Display'] mb-2">с 0 до 24,6 млн ₽</div>
              <div className="w-16 h-px bg-[#C5A880] mx-auto my-4" />
              <div className="text-white/55 text-lg">Производство работает на полных мощностях</div>
            </div>
          </div>
        </div>
      </section>

      {/* ─── НАЧАЛО ПУТИ ─── */}
      <section className="py-20 bg-[#F8F9FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-[#1A2B4C] font-['Playfair_Display'] mb-3">
              Начало пути: Январь — Июль 2023
            </h2>
            <div className="w-16 h-px bg-[#C5A880] mx-auto mb-4" />
            <p className="text-gray-500">Первые месяцы работы: как выглядел старт проекта</p>
          </div>

          <div className="bg-white rounded-2xl border border-[#C5A880]/20 overflow-hidden shadow-sm">
            <div className="p-8">
              <div className="bg-[#F8F9FA] rounded-xl overflow-hidden mb-8 border border-[#C5A880]/10">
                <img
                  src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/95170b13d35adc3bc1ad03e9935f3022.png"
                  alt="Аналитика продаж - Январь - Июль 2023"
                  className="w-full h-auto object-contain"
                />
              </div>

              <div className="grid md:grid-cols-3 gap-5 mb-8">
                {[
                  { label: 'Период', value: '01 янв — 31 июля 2023', sub: 'Первые 7 месяцев работы', dark: false },
                  { label: 'Заказано товаров', value: '571 шт', sub: 'Стабильный рост заказов', dark: true },
                  { label: 'Динамика', value: '📈', sub: 'Уверенный рост с января', dark: true },
                ].map((s, i) => (
                  <div key={i} className={`rounded-xl p-6 text-center ${s.dark ? 'bg-[#1A2B4C]' : 'bg-[#F8F9FA] border border-[#C5A880]/20'}`}>
                    <div className={`text-xs font-semibold tracking-widest uppercase mb-3 ${s.dark ? 'text-[#C5A880]/60' : 'text-[#1A2B4C]/40'}`}>{s.label}</div>
                    <div className={`text-2xl font-bold font-['Playfair_Display'] mb-1 ${s.dark ? 'text-white' : 'text-[#1A2B4C]'}`}>{s.value}</div>
                    <div className={`text-xs ${s.dark ? 'text-white/40' : 'text-gray-400'}`}>{s.sub}</div>
                  </div>
                ))}
              </div>

              <div className="bg-[#1A2B4C]/5 border border-[#C5A880]/20 rounded-xl p-6">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-[#1A2B4C] rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-seedling-line text-lg text-[#C5A880]"></i>
                  </div>
                  <div>
                    <h6 className="font-bold text-[#1A2B4C] mb-3 font-['Playfair_Display']">Что показывает график?</h6>
                    <div className="space-y-2 text-sm text-gray-600">
                      <p><strong className="text-[#1A2B4C]">Стабильный старт:</strong> График показывает уверенный рост заказов с января по июль 2023 года. Несмотря на естественные колебания, общий тренд направлен вверх.</p>
                      <p><strong className="text-[#1A2B4C]">571 заказанный товар</strong> за первые 7 месяцев — результат правильной настройки карточек, SEO-оптимизации и первых рекламных кампаний.</p>
                      <p><strong className="text-[#1A2B4C]">Фундамент для роста:</strong> Этот период заложил основу для дальнейшего масштабирования.</p>
                      <p className="text-[#C5A880] font-semibold mt-3">💡 Успешный запуск — это не мгновенный взрыв, а планомерное наращивание оборотов месяц за месяцем.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ─── ДЕТАЛЬНАЯ АНАЛИТИКА ─── */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-[#1A2B4C] font-['Playfair_Display'] mb-3">
              Детальная аналитика продаж
            </h2>
            <div className="w-16 h-px bg-[#C5A880] mx-auto mb-4" />
            <p className="text-gray-500">Динамика роста: от ноября 2024 к маю 2025</p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 mb-8">
            {[
              {
                label: 'Ноябрь 2024',
                img: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/bc6f6b803f72c01e54e1ed7789ee5623.png',
                alt: 'Детальная аналитика заказов - Ноябрь 2024',
              },
              {
                label: 'Май 2025',
                img: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/81d4c8ad1679454520d09d4b24cbab36.png',
                alt: 'Детальная аналитика доставок - Май 2025',
              },
            ].map((item, i) => (
              <div key={i} className="bg-[#F8F9FA] rounded-2xl p-5 border border-[#C5A880]/20">
                <div className="mb-4 text-center">
                  <span className="inline-block bg-[#1A2B4C] text-[#C5A880] px-5 py-2 rounded-full text-sm font-bold tracking-wide">
                    {item.label}
                  </span>
                </div>
                <div className="bg-white rounded-xl overflow-hidden border border-[#C5A880]/10 shadow-sm">
                  <img src={item.img} alt={item.alt} className="w-full h-auto object-contain" />
                </div>
              </div>
            ))}
          </div>

          <div className="bg-[#1A2B4C]/5 border border-[#C5A880]/20 rounded-xl p-6">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-[#1A2B4C] rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-bar-chart-box-line text-lg text-[#C5A880]"></i>
              </div>
              <div>
                <h6 className="font-bold text-[#1A2B4C] mb-3 font-['Playfair_Display']">Что показывают данные?</h6>
                <div className="space-y-2 text-sm text-gray-600">
                  <p><strong className="text-[#1A2B4C]">Ноябрь 2024:</strong> Детальная статистика по всем заказам показывает стабильный рост и высокий спрос на продукцию.</p>
                  <p><strong className="text-[#1A2B4C]">Май 2025:</strong> Высокий процент доставленных заказов подтверждает эффективность логистической системы.</p>
                  <p className="text-[#C5A880] font-semibold mt-3">💡 За полгода (с ноября 2024 по май 2025) результаты удвоились — стабильное масштабирование бизнеса.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ─── КОНКУРЕНТНАЯ ПОЗИЦИЯ ─── */}
      <section className="py-20 bg-[#1A2B4C] relative overflow-hidden">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full border border-[#C5A880]/8 translate-x-1/3 -translate-y-1/3 pointer-events-none" />
        <div className="absolute bottom-0 left-0 w-[350px] h-[350px] rounded-full border border-[#C5A880]/8 -translate-x-1/3 translate-y-1/3 pointer-events-none" />

        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 bg-[#C5A880]/15 border border-[#C5A880]/30 text-[#C5A880] px-5 py-2 rounded-full text-xs font-semibold tracking-widest uppercase mb-5">
              Товар-локомотив
            </div>
            <h2 className="text-3xl font-bold text-white font-['Playfair_Display'] mb-3">
              Рост в категории «Джемпер женский»
            </h2>
            <div className="w-16 h-px bg-[#C5A880] mx-auto mb-4" />
            <p className="text-white/50">Как мы вывели продукт в топ-2% продавцов категории</p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-8">
            {[
              {
                badge: 'Октябрь 2024 — Этап 1',
                img: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/fcf6b044d7ac890d06b165a480d89fc4.png',
                alt: 'Конкурентная позиция Ozon - Джемпер женский - Топ 5%',
                stats: [
                  { label: 'Позиция', value: '#48', sub: 'из тысячи продавцов' },
                  { label: 'Оборот', value: '1,5 млн ₽', sub: 'по одной категории' },
                  { label: 'Эффективность', value: '184%', sub: 'метрика' },
                  { label: 'Достижение', value: 'ТОП 5%', sub: 'лучших продавцов', gold: true },
                ],
              },
              {
                badge: 'Октябрь 2024 — Этап 2',
                img: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/77599199025dd2c459dcdfcd8b4ec54b.png',
                alt: 'Конкурентная позиция Ozon - Джемпер женский - Детальная таблица',
                stats: [
                  { label: 'Позиция', value: '#45', sub: 'из тысячи продавцов' },
                  { label: 'Оборот', value: '5,9 млн ₽', sub: 'по одной категории' },
                  { label: 'Рост', value: '25%', sub: 'за месяц' },
                  { label: 'Достижение', value: 'ТОП 2%', sub: 'лучших продавцов', gold: true },
                ],
              },
            ].map((col, i) => (
              <div key={i} className="bg-white/6 border border-[#C5A880]/15 rounded-2xl p-6">
                <div className="mb-4 text-center">
                  <span className="inline-block bg-[#C5A880] text-[#1A2B4C] px-5 py-2 rounded-full text-sm font-bold">
                    {col.badge}
                  </span>
                </div>
                <div className="bg-white/10 rounded-xl overflow-hidden mb-5">
                  <img src={col.img} alt={col.alt} className="w-full h-auto object-contain" />
                </div>
                <div className="grid grid-cols-2 gap-3">
                  {col.stats.map((s, j) => (
                    <div key={j} className={`rounded-xl p-4 text-center ${s.gold ? 'bg-[#C5A880]' : 'bg-white/8 border border-[#C5A880]/15'}`}>
                      <div className={`text-xs font-semibold tracking-wide uppercase mb-1 ${s.gold ? 'text-[#1A2B4C]/60' : 'text-[#C5A880]/60'}`}>{s.label}</div>
                      <div className={`text-xl font-bold font-['Playfair_Display'] ${s.gold ? 'text-[#1A2B4C]' : 'text-white'}`}>{s.value}</div>
                      <div className={`text-xs mt-0.5 ${s.gold ? 'text-[#1A2B4C]/60' : 'text-white/40'}`}>{s.sub}</div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="bg-white/6 border border-[#C5A880]/20 rounded-2xl p-7">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-[#C5A880] rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-lightbulb-line text-lg text-[#1A2B4C]"></i>
              </div>
              <div>
                <h6 className="font-bold text-white mb-3 font-['Playfair_Display']">Как мы этого добились?</h6>
                <div className="space-y-2 text-sm text-white/55">
                  <p><strong className="text-[#C5A880]">Товар-локомотив:</strong> Джемпер женский стал основным драйвером продаж. Сфокусировали бюджет на его продвижении, чтобы он «тянул» за собой остальной ассортимент из 1 400 SKU.</p>
                  <p><strong className="text-[#C5A880]">Гео-распределённая логистика:</strong> Товар размещён на всех складах Ozon по России → быстрая доставка → высокий рейтинг в поиске.</p>
                  <p><strong className="text-[#C5A880]">SEO-оптимизация:</strong> Карточка закрывает все боли аудитории Plus Size через инфографику и детальное описание посадки.</p>
                  <p className="text-[#C5A880] font-semibold mt-3">Результат: позиция #45 из тысячи продавцов, оборот 5,9 млн ₽ по одной категории, вход в топ-2% лучших.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ─── ГОДОВОЙ ТРЕНД ─── */}
      <section className="py-20 bg-[#F8F9FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-[#1A2B4C] font-['Playfair_Display'] mb-3">
              Рост не останавливается
            </h2>
            <div className="w-16 h-px bg-[#C5A880] mx-auto mb-4" />
            <p className="text-gray-500">Ноябрь 2024 — Ноябрь 2025: системный подход приносит стабильные результаты</p>
          </div>

          <div className="bg-white rounded-2xl border border-[#C5A880]/20 overflow-hidden shadow-sm mb-8">
            <div className="p-8">
              <div className="bg-[#F8F9FA] rounded-xl overflow-hidden mb-8 border border-[#C5A880]/10">
                <img
                  src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/ab294d0c1d064ab94694b7da606e91f5.png"
                  alt="Тренды продаж Джемпер - Ноябрь 2024 - Май 2025"
                  className="w-full h-auto object-contain"
                />
              </div>

              <div className="grid md:grid-cols-2 gap-5 mb-6">
                {[
                  { label: 'Период анализа', value: '26 ноя 2024 — 25 ноя 2025', sub: 'Годовой тренд по категории «Джемпер»', dark: false },
                  { label: 'Рост продаж', value: '+48%', sub: 'быстрее, чем общие продажи в категории', dark: true },
                ].map((s, i) => (
                  <div key={i} className={`rounded-xl p-6 text-center ${s.dark ? 'bg-[#1A2B4C]' : 'bg-[#F8F9FA] border border-[#C5A880]/20'}`}>
                    <div className={`text-xs font-semibold tracking-widest uppercase mb-3 ${s.dark ? 'text-[#C5A880]/60' : 'text-[#1A2B4C]/40'}`}>{s.label}</div>
                    <div className={`text-3xl font-bold font-['Playfair_Display'] mb-1 ${s.dark ? 'text-[#C5A880]' : 'text-[#1A2B4C]'}`}>{s.value}</div>
                    <div className={`text-xs ${s.dark ? 'text-white/40' : 'text-gray-400'}`}>{s.sub}</div>
                  </div>
                ))}
              </div>

              <div className="grid md:grid-cols-2 gap-5 mb-8">
                {[
                  { label: 'Всех продавцов', value: '14,4 млрд ₽', sub: 'Общая сумма заказов в категории', growth: '↑ 4 046% рост', dark: false },
                  { label: 'Моя сумма заказов', value: '40,4 млн ₽', sub: 'Мой оборот в категории', growth: '↑ 5 997% рост', dark: true },
                ].map((s, i) => (
                  <div key={i} className={`rounded-xl p-6 text-center ${s.dark ? 'bg-[#1A2B4C]' : 'bg-[#F8F9FA] border border-[#C5A880]/20'}`}>
                    <div className={`text-xs font-semibold tracking-widest uppercase mb-3 ${s.dark ? 'text-[#C5A880]/60' : 'text-[#1A2B4C]/40'}`}>{s.label}</div>
                    <div className={`text-3xl font-bold font-['Playfair_Display'] mb-1 ${s.dark ? 'text-[#C5A880]' : 'text-[#1A2B4C]'}`}>{s.value}</div>
                    <div className={`text-xs mb-2 ${s.dark ? 'text-white/40' : 'text-gray-400'}`}>{s.sub}</div>
                    <div className={`text-sm font-semibold ${s.dark ? 'text-[#C5A880]' : 'text-[#1A2B4C]'}`}>{s.growth}</div>
                  </div>
                ))}
              </div>

              <div className="bg-[#1A2B4C]/5 border border-[#C5A880]/20 rounded-xl p-6">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-[#1A2B4C] rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-line-chart-line text-lg text-[#C5A880]"></i>
                  </div>
                  <div>
                    <h6 className="font-bold text-[#1A2B4C] mb-3 font-['Playfair_Display']">Что показывают цифры?</h6>
                    <div className="space-y-2 text-sm text-gray-600">
                      <p><strong className="text-[#1A2B4C]">Опережающий рост:</strong> Мои продажи растут на <strong className="text-[#C5A880]">48% быстрее</strong>, чем средние показатели по всей категории.</p>
                      <p><strong className="text-[#1A2B4C]">Масштаб достижения:</strong> При общем обороте категории в 14,4 млрд ₽, мой показатель <strong className="text-[#C5A880]">40,4 млн ₽</strong> — результат точечной работы с 1 400 SKU.</p>
                      <p><strong className="text-[#1A2B4C]">Устойчивый тренд:</strong> Рост <strong className="text-[#C5A880]">5 997%</strong> за год показывает, что система продолжает масштабироваться.</p>
                      <p className="text-[#C5A880] font-semibold mt-3">💡 Правильная стратегия + системная работа = опережающий рост даже в высококонкурентных категориях.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Ноябрь 2025 */}
          <div className="bg-[#1A2B4C] rounded-2xl p-8 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-[400px] h-[400px] rounded-full border border-[#C5A880]/8 translate-x-1/3 -translate-y-1/3 pointer-events-none" />
            <div className="relative z-10">
              <div className="text-center mb-8">
                <span className="inline-block bg-[#C5A880] text-[#1A2B4C] px-6 py-3 rounded-full text-sm font-bold tracking-wide">
                  Детальная статистика продаж · Ноябрь 2025
                </span>
              </div>
              <div className="bg-white/10 rounded-xl overflow-hidden mb-8 border border-[#C5A880]/20">
                <img
                  src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/d44799235440d5951c31a05dd25a7e19.png"
                  alt="Детальная статистика продаж - Ноябрь 2025"
                  className="w-full h-auto object-contain"
                />
              </div>
              <div className="bg-white/6 border border-[#C5A880]/20 rounded-xl p-6">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-[#C5A880] rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-trophy-line text-lg text-[#1A2B4C]"></i>
                  </div>
                  <div>
                    <h6 className="font-bold text-white mb-3 font-['Playfair_Display']">Стабильное лидерство в категории</h6>
                    <div className="space-y-2 text-sm text-white/55">
                      <p><strong className="text-[#C5A880]">Категория «Джемпер женский» удерживает позицию в топ-2% лучших продавцов</strong> — это не случайный всплеск, а результат системной работы.</p>
                      <p><strong className="text-[#C5A880]">Что это значит?</strong> Из тысячи продавцов в этой высококонкурентной категории мы стабильно находимся среди лучших 2%.</p>
                      <p className="text-[#C5A880] font-semibold mt-3">💡 Топ-2% — это не финиш, а стабильная рабочая позиция, которая обеспечивает постоянный поток заказов и загрузку производства на полную мощность.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ─── ПОЧЕМУ ФЛАГМАНСКИЙ ─── */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="bg-[#F8F9FA] border border-[#C5A880]/25 rounded-2xl p-8 md:p-10">
            <div className="flex items-start gap-5">
              <div className="w-14 h-14 bg-[#1A2B4C] rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-trophy-line text-2xl text-[#C5A880]"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-[#1A2B4C] mb-4 font-['Playfair_Display']">Почему это флагманский кейс?</h3>
                <div className="space-y-3 text-gray-600">
                  <p><strong className="text-[#1A2B4C]">Работа с 1 400 SKU</strong> и нишей Plus Size (где очень высока требовательность аудитории к посадке и визуалу) — это высший пилотаж управления.</p>
                  <p><strong className="text-[#1A2B4C]">Самое ценное здесь — динамика.</strong> Мы показываем не просто быстрый старт, а устойчивый рост на длинной дистанции (с 0 до 24,6 млн). Это лучшее доказательство эффективности нашей системы «вдолгую».</p>
                  <p className="text-[#C5A880] font-semibold">Гео-распределённая логистика + тотальная проработка контента + товары-локомотивы = стабильный рост месяц за месяцем.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ─── CTA ─── */}
      <section className="py-20 bg-[#1A2B4C] relative overflow-hidden">
        <div className="absolute top-0 left-1/2 w-[600px] h-[600px] rounded-full border border-[#C5A880]/8 -translate-x-1/2 -translate-y-1/2 pointer-events-none" />
        <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full border border-[#C5A880]/8 translate-x-1/3 translate-y-1/3 pointer-events-none" />

        <div className="max-w-3xl mx-auto px-6 text-center relative z-10">
          <div className="inline-flex items-center gap-2 bg-[#C5A880]/15 border border-[#C5A880]/30 text-[#C5A880] px-5 py-2 rounded-full text-xs font-semibold tracking-widest uppercase mb-8">
            Следующий шаг
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white font-['Playfair_Display'] mb-4">
            Хотите такой же результат?
          </h2>
          <div className="w-16 h-px bg-[#C5A880] mx-auto my-6" />
          <p className="text-white/55 text-lg mb-10 leading-relaxed">
            Ваше производство способно переварить такой рост? Выстроим систему продаж, которая обеспечит вас заказами на годы вперёд.
          </p>
          <Link
            to="/#lead-form"
            className="inline-block bg-[#C5A880] text-[#1A2B4C] px-10 py-5 rounded-full text-lg font-bold hover:bg-white hover:text-[#1A2B4C] hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Обсудить стратегию масштабирования
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
